import { useEffect, useState } from "react";

const Q = "(max-width: 767.98px)";

// v18: telefoonbreedte (< 768px), volgt draaien en venstergrootte.
export function useSmal() {
  const [m, setM] = useState(() => window.matchMedia(Q).matches);
  useEffect(() => {
    const mq = window.matchMedia(Q);
    const h = () => setM(mq.matches);
    mq.addEventListener("change", h);
    return () => mq.removeEventListener("change", h);
  }, []);
  return m;
}
